import {
  getDefinitionAudioCachedV1Api,
  getExampleAudioCachedV1Api,
  getTitleAudioCachedV1Api,
  getUsageAudioCachedV1Api,
} from '@repo/sdk';
import type { IKaraokeCachedResult } from './karaoke-cached-types';

function unwrap(
  data: { exists: false } | { exists: true; value: IKaraokeCachedResult } | undefined,
): IKaraokeCachedResult | null {
  if (!data?.exists) {
    return null;
  }
  return data.value;
}

function reportAudioLoadFailure(label: string, error: unknown): void {
  if (typeof window === 'undefined') {
    return;
  }
  void import('@sentry/browser').then(({ addBreadcrumb }) => {
    addBreadcrumb({
      category: 'audio',
      level: 'warning',
      message: `cached audio load failed: ${label}`,
      data: { reason: error instanceof Error ? error.message : String(error) },
    });
  });
}

export async function loadTitleAudioCached(slug: string): Promise<IKaraokeCachedResult | null> {
  try {
    const res = await getTitleAudioCachedV1Api(slug);
    return unwrap(res.data?.data);
  } catch (error) {
    reportAudioLoadFailure(`title:${slug}`, error);
    return null;
  }
}

export async function loadDefinitionAudioCached(
  slug: string,
): Promise<IKaraokeCachedResult | null> {
  try {
    const res = await getDefinitionAudioCachedV1Api(slug);
    return unwrap(res.data?.data);
  } catch (error) {
    reportAudioLoadFailure(`definition:${slug}`, error);
    return null;
  }
}

export async function loadUsageAudioCached(slug: string): Promise<IKaraokeCachedResult | null> {
  try {
    const res = await getUsageAudioCachedV1Api(slug);
    return unwrap(res.data?.data);
  } catch (error) {
    reportAudioLoadFailure(`usage:${slug}`, error);
    return null;
  }
}

export async function loadExampleAudioCached(
  slug: string,
  exampleId: number,
): Promise<IKaraokeCachedResult | null> {
  try {
    const res = await getExampleAudioCachedV1Api(slug, exampleId);
    return unwrap(res.data?.data);
  } catch (error) {
    reportAudioLoadFailure(`example:${slug}#${exampleId}`, error);
    return null;
  }
}
